import React, { useState, useEffect } from "react";
import Style from './lifeline.module.scss'

const LifiLine = ({  available_lifelines = [],lifeLineUsed=[], lifeClick,}) => {
      const isUsed = (id) => {
        return lifeLineUsed?.some((item) => item.lifeline_id?.toString() === id?.toString());
    };


    return (
        <>
            <div className={Style.lifelinecontainer}>

                {
                    available_lifelines?.length > 0 && available_lifelines?.map((e) => {
                        return (
                            <React.Fragment key={e._id}>
                                <div className={Style.lifelineitem}>
                                    {isUsed(e._id) && <div className={Style.blurBox} />}
                                    <div className={Style.lifelineimg} onClick={()=>lifeClick(e._id)}>
                                        <img src={e.icon} alt={e.name} className={Style.lifeImg} />
                                    </div>
                                </div>
                            </React.Fragment>
                        )
                    })}
            </div>
        </>
    );
};

export default LifiLine;
